/**
 * Check if a is after b
 */
export default function isAfter(a, b) {
  return a >= b;
}
